import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from '../service/spinner.service';
import * as Sentry from '@sentry/browser';
import { AlertService } from '../service/alert.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private authenticationService: AuthenticationService, private alertService: AlertService, private translateService: TranslateService,
		private spinnerService: SpinnerService, private router: Router) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(catchError(err => {
			if ([401, 403].indexOf(err.status) !== -1) {
				//auto logout if 401 response returned from api
				this.authenticationService.logout();
				this.router.navigate(['/']);
				return;
			}
			else {
				Sentry.setExtra('header', request.headers);
				Sentry.setExtra('responseType', request.responseType);
				Sentry.setExtra('body', request.body);
				Sentry.setExtra('status', err.status);
				Sentry.setExtra('method', request.method);
				Sentry.setExtra('params', request.params);
				Sentry.setExtra('url', request.url);
				Sentry.setExtra('urlWithParams', request.urlWithParams);
				Sentry.setExtra('withCredentials', request.withCredentials);
				Sentry.captureException(err);
			}


			const error = JSON.stringify(err);
			this.spinnerService.hide();
			if (err.status === 401) {
				this.alertService.showError(this.translateService.instant('Error.message.timeout'));
			}
			else if (environment.production && err.status !== 0 && err.status !== 500) {
				this.alertService.showError(this.parseObjResponse(err));
			} else if (err.status === 500) {
				this.alertService.showError(this.translateService.instant('Error.message.unexpectedError'));
			}
			else if (!environment.production) {
				//this.alertService.showError(this.parseObjResponse(err));
				this.alertService.showError(error.toString() + this.parseObjResponse(err));
			}
			return throwError(() => new Error());
		}).bind(this))
	}

	parseObjResponse = (resData) => {
		if (typeof resData !== 'object') resData = JSON.parse(resData)
		let response = ''
		Object.keys(resData["error"]).forEach((item, index) => {
			response += `    ${item}: ${resData["error"][item]}     `
		});
		console.log(response)
		return response
	}
}
